export var ComposerModuleName;
(function (ComposerModuleName) {
    ComposerModuleName["BulletList"] = "bulletList";
    ComposerModuleName["NumberedList"] = "numberedList";
    ComposerModuleName["LargeHeader"] = "largeHeader";
    ComposerModuleName["MediumHeader"] = "mediumHeader";
    ComposerModuleName["Image"] = "image";
    ComposerModuleName["Attachment"] = "attachment";
    ComposerModuleName["Emoji"] = "emoji";
    ComposerModuleName["Mention"] = "mention";
    ComposerModuleName["Embed"] = "embed";
    ComposerModuleName["Code"] = "code";
})(ComposerModuleName || (ComposerModuleName = {}));
export var AppsEnum;
(function (AppsEnum) {
    AppsEnum["Giphy"] = "giphy";
})(AppsEnum || (AppsEnum = {}));
//# sourceMappingURL=@types.js.map